import axios from "axios";

import { baseUrl } from "./baseUrl";

const api = axios.create({
    baseURL: `${baseUrl}/admin/user`,
    headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
    },
});

// Add request interceptor to dynamically set the token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('cc-t') || sessionStorage.getItem('cc-t');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export const getNotificationTypes = async () => {
    try {
        const response = await api.get("/list-types");
        return response.data;
    } catch (error) {
        console.error("Error fetching notification types:", error);
        throw error;
    }
}

export const updateNotificationType = async (data) => {
    try {
        const response = await api.put(`/edit-types`, data);
        return response.data;
    } catch (error) {
        console.error("Error updating notification type:", error);
        throw error;
    }
};

export const deleteNotificationType = async (id) => {
    try {
        const response = await api.delete(`/delete-types?id=${id}`);
        return response.data;
    } catch (error) {
        console.error("Error deleting notification type:", error);
        throw error;
    }
}

export const createNotificationType = async (data) => {
    try {
        const response = await api.post(`/add-types`, data);
        return response.data;
    } catch (error) {
        console.error("Error creating notification type:", error);
        throw error;
    }
};

export const getNotifications = async () => {
    try {
        const response = await api.get("/list-notification");
        return response.data;
    } catch (error) {
        console.error("Error fetching notification types:", error);
        throw error;
    }
}

export const updateNotifications = async (data) => {
    try {
        const response = await api.put(`/edit-notification`, data);
        return response.data;
    } catch (error) {
        console.error("Error updating notification type:", error);
        throw error;
    }
};

export const deleteNotifications = async (id) => {
    try {
        const response = await api.delete(`/delete-notification?id=${id}`);
        return response.data;
    } catch (error) {
        console.error("Error deleting notification type:", error);
        throw error;
    }
}

export const createNotifications = async (data) => {
    try {
        const response = await api.post(`/add-notification`, data);
        return response.data;
    } catch (error) {
        console.error("Error creating notification type:", error);
        throw error;
    }
};

export const getNotificationById = async (id) => {
    try {
        const response = await api.get(`/view-notification?id=${id}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching notification by ID:", error);
        throw error;
    }
}

export const getAdminNotifications = async () => {
    try {
        const response = await api.get("/list-admin-notifications");
        return response.data.data || [];
    } catch (error) {
        console.error("Error fetching admin notifications:", error);
        throw error;
    }
}

export const markNotificationAsRead = async (id) => {
    try {
        const response = await api.post(`/mark-notification-read`, { notificationId: id });
        return response.data;
    } catch (error) {
        console.error("Error marking notification as read:", error);
        throw error;
    }
}

export const markAllNotificationsAsRead = async () => {
    try {
        const response = await api.post(`/mark-all-notifications-read`);
        return response.data;
    } catch (error) {
        console.error("Error marking all notifications as read:", error);
        throw error;
    }
}

// Notification Logs API functions
const logsApi = axios.create({
    baseURL: `${baseUrl}/admin/notification-logs`,
    headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
    },
});

// Add request interceptor to dynamically set the token
logsApi.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('cc-t') || sessionStorage.getItem('cc-t');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export const getNotificationLogs = async (params = {}) => {
    try {
        const response = await logsApi.get("/", { params });
        return response.data;
    } catch (error) {
        console.error("Error fetching notification logs:", error);
        throw error;
    }
}

export const getNotificationLogStats = async () => {
    try {
        const response = await logsApi.get("/stats");
        return response.data;
    } catch (error) {
        console.error("Error fetching notification log stats:", error);
        throw error;
    }
}